import { Chip, IconButton, Tooltip } from '@mui/material';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import IconeEspelhoProcesso from '../../img/icones/IconeEspelhoProcesso';
import { Processo } from '../../modelo';
import { AlertaDto } from '../../modelo/dto/AlertaDto';
import RouterStore from '../../store/RouterStore';
import LabelTarefa from '../escaninho/LabelTarefa';
import SistemaDeOrigem from '../escaninho/SistemaDeOrigem';
import PartesProcesso from './PartesProcesso';
import './css/info-processo.css';
interface IpropsInfoProcessoView {
    processo: Processo;
    espelho: any;
    gabinetesProcessoImportado?: string[];
    indicadores: any;
    alertas: AlertaDto[];
    tarefaFluxoPje: any;
    children: any;
}
class InformacoesProcessoView extends React.Component<IpropsInfoProcessoView> {
    processoNoGe = false;

    abrirEspelho = () => {
        RouterStore.abrirJanela('/espelhoProcesso/' + this.props.processo.identificadorProcesso);
    }

    componentDidMount() {
        // let processo = await ProcessoService.recuperaPorSearch({ gabinete: UsuarioStore.gabinete, idsProcessos: [this.props.processo.identificadorProcesso] });
        // runInAction(() => {
        //     if (processo?.resultado.length > 0) {
        //         // this.processoNoGe = true;
        //         RouterStore.push('/escaninho/gerencial?idProcesso=' + this.props.processo.identificadorProcesso)
        //     }
        // });
    }

    constructor(props: IpropsInfoProcessoView) {
        super(props);

        makeObservable(this, {
            processoNoGe: observable,
});
    }

    render() {
        const classeSigla = this.props.processo?.classeJudicial?.sigla || '';
        const classeDescricao = this.props.processo?.classeJudicial?.descricao || '-';
        const numeroProcesso = this.props.processo?.numero || this.props.processo?.numeroProcesso || '-';
        const relator = (() => {
            const valor = this.props.processo?.relator as any;
            if (!valor) {
                return '';
            }
            return typeof valor === 'string' ? valor : (valor?.nome || '');
        })();

        return (
            <div>
                <span className="titulo">
                    <b className="aCenter divFlexRow">
                        Processo: {classeSigla} - {numeroProcesso}
                        <SistemaDeOrigem processo={this.props.processo} />
                        {/* {this.processoNoGe &&
                            <AbrirProcessoNoEscaninho idProcesso={this.props.processo.identificadorProcesso} />
                        } */}
                        {this.props.espelho &&
                            <IconButton title="Espelho do Processo" onClick={this.abrirEspelho}>
                                <IconeEspelhoProcesso />
                            </IconButton>
                        }
                    </b>
                </span>
                <div className='divFlexColumn' style={{ marginTop: '8px' }}>
                    <div><b className="titulo">Classe:</b> {classeDescricao}</div>
                    <div>
                        <PartesProcesso
                            partes={((this.props.children) as any).props.partes}
                            mensagemErro={((this.props.children) as any).props.mensagemErro}
                        />
                    </div>
                    <div>
                        {this.props.indicadores && this.props.indicadores.length > 0 &&
                            <div className="titulo"><b>Indicadores:</b>
                                {this.props.indicadores.map((indicador, index) => {
                                    if (indicador.isEtiqueta) {
                                        return <Tooltip title='Chip PJe' key={index}><Chip label={indicador.descricao} color="success" variant="outlined" /></Tooltip>;
                                    } else {
                                        return <Tooltip title='Indicador' key={index}><Chip label={indicador.descricao} color="primary" variant="outlined" /></Tooltip>;
                                    }
                                }
                                )}
                            </div>
                        }
                    </div>

                    {this.props.alertas && this.props.alertas.length > 0 &&
                        (<div style={{ paddingTop: '5px' }}>
                            <b className="titulo">Alertas:</b>
                            <ul>
                                {this.props.alertas.map((alertaProcesso, index) => <li key={'li-alerta-' + index}>{alertaProcesso.alerta?.descricaoAlerta}</li>)}
                            </ul>
                        </div>)
                    }
                    {this.props.processo && !this.props.processo.ehPje && this.props.processo.sigUnAdm &&
                        <div style={{ paddingTop: '5px' }}><b className="titulo">Unidade Atual:</b> {this.props.processo.sigUnAdm}</div>
                    }
                    {this.props.tarefaFluxoPje && this.props.tarefaFluxoPje.tarefaAtual &&
                        <div style={{ paddingTop: '5px' }}><LabelTarefa processo={this.props.processo} /> {this.props.tarefaFluxoPje.tarefaAtual}</div>
                    }
                    {this.props.processo && this.props.processo.relator &&
                        <div style={{ paddingTop: '5px' }}><b className="titulo">Relator:</b> {relator}</div>
                    }
                    {this.props.processo && this.props.processo.orgaoJulgador &&
                        <div style={{ paddingTop: '5px' }}><b className="titulo">Órgão Julgador:</b> {this.props.processo.orgaoJulgador?.sigla || '-'}</div>
                    }
                    {this.props.processo && this.props.processo.orgaoJulgadorColegiado &&
                        <div style={{ paddingTop: '5px' }}><b className="titulo">Órgão Julgador Colegiado:</b> {this.props.processo.orgaoJulgadorColegiado?.sigla || '-'}</div>
                    }
                    {this.props.processo && (this.props.processo.dataAutuacaoTst || this.props.processo.autuadoEm) &&
                        <div style={{ paddingTop: '5px', paddingBottom: '5px' }}><b className="titulo">Data de Autuação:</b> {String(this.props.processo.autuadoEm || this.props.processo.dataAutuacaoTst || '').split(' ')[0]}</div>
                    }
                    {this.props.gabinetesProcessoImportado &&
                        <div style={{ paddingBottom: '5px' }}>
                            <b className="titulo">
                                {this.props.gabinetesProcessoImportado.length <= 1
                                    ? 'Processo Importado na Unidade:'
                                    : 'Processo Importado nas Unidades:'}
                            </b>{' '}
                            {this.props.gabinetesProcessoImportado.join(', ') || 'Não importado'}
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default observer(InformacoesProcessoView);
